module.exports = __webpack_public_path__ + "img/天气实况.d642221d.png";